import React, { useMemo } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { WEB_ROUTES } from "../constants.js";
import { baseRoute } from "../Helper";
import PublicRoute from "../Components/Routes/PublicRoute.js";
import ProtectedRoute, {
  AdminOnlyRoute,
} from "../Components/Routes/ProtectedRoute.js";
import ProtectedLayout from "../Components/Layouts/ProtectedLayout.js";

import Account from "../Pages/Account";
import Dashboard from "../Pages/Dashboard";
import Analytics from "../Pages/Analytics";
import AgentManagement from "../Pages/AgentManagement";
import AppointmentManagement from "../Pages/AppointmentManagement";
import InvoiceManagement from "../Pages/InvoiceManagement";
import QuoteManagement from "../Pages/QuoteManagement";
import Setting from "../Pages/Setting";
import UserManagement from "../Pages/UserManagement";
import SendNotificationScreen from "../Pages/SendNotification/SendNotificationScreen.js";
import ServiceManagement from "../Pages/ServiceManagement";
import ShopManagement from "../Pages/ShopManagement";
import Messages from "../Pages/Messages";
import WalletManagement from "../Pages/WalletManagement";

/**
 * Central route map — same role as RN `navigation/MainStack.js` + stack wiring.
 */
export default function AppNavigation() {
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={WEB_ROUTES.ACCOUNT}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.DASHBOARD}
        exact
        path={baseRoute(WEB_ROUTES.DASHBOARD)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.ANALYTICS}
        exact
        path={baseRoute(WEB_ROUTES.ANALYTICS)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <Analytics />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.WALLET}
        exact
        path={baseRoute(WEB_ROUTES.WALLET)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <WalletManagement />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.AGENT_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.AGENT_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <AgentManagement />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.QUOTE_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.QUOTE_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <QuoteManagement />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.INVOICE_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.INVOICE_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <InvoiceManagement />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.APPOINTMENT_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.APPOINTMENT_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <AppointmentManagement />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.USER_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.USER_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <UserManagement />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.SEND_NOTIFICATION}
        exact
        path={baseRoute(WEB_ROUTES.SEND_NOTIFICATION)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <SendNotificationScreen />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.SERVICE_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.SERVICE_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <ServiceManagement />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.SHOP_MANAGEMENT}
        exact
        path={baseRoute(WEB_ROUTES.SHOP_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <AdminOnlyRoute>
              <ProtectedLayout isSearchBar={false}>
                <ShopManagement />
              </ProtectedLayout>
            </AdminOnlyRoute>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.SETTING}
        exact
        path={baseRoute(WEB_ROUTES.SETTING)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={WEB_ROUTES.SUPPORT_CHAT}
        exact
        path={baseRoute(WEB_ROUTES.SUPPORT_CHAT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Messages />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
    ];
  }, []);

  return (
    <Routes>
      {ROUTES.map((item) => item)}
      <Route
        path={baseRoute("*")}
        element={<Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} />}
      />
    </Routes>
  );
}
